import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { useLanguage } from '../../../contexts/LanguageContext';
import Image from '../../../components/AppImage';


const ProfileHeader = ({ pilgrim, onAction }) => {
  const { t, currentLanguage } = useLanguage();

  const handleAssignToGroup = () => {
    const groupName = prompt(
      t('pilgrimProfile.enterGroupName')
    );
    
    if (groupName && groupName?.trim()) {
      alert(
        t('pilgrimProfile.assignmentSuccess')?.replace('{firstName}', currentLanguage === 'ar' ? pilgrim?.arabicFirstName : pilgrim?.firstName)?.replace('{lastName}', currentLanguage === 'ar' ? pilgrim?.arabicLastName : pilgrim?.lastName)?.replace('{groupName}', groupName)
      );
      if (onAction) {
        onAction({ type: 'assign_group', groupName });
      }
    } else if (groupName !== null) {
      alert(t('pilgrimProfile.invalidGroupName'));
    }
  };

  const statusConfig = {
    active: { color: 'bg-success/10 text-success', label: t('pilgrimProfile.active') },
    pending: { color: 'bg-warning/10 text-warning', label: t('pilgrimProfile.pending') },
    completed: { color: 'bg-primary/10 text-primary', label: t('pilgrimProfile.completed') },
    cancelled: { color: 'bg-error/10 text-error', label: t('pilgrimProfile.cancelled') }
  };

  const currentStatus = statusConfig?.[pilgrim?.status] || statusConfig?.pending;

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6 lg:p-8 shadow-warm">
      <div className="flex flex-col lg:flex-row gap-6 lg:gap-8">
        <div className="flex flex-col sm:flex-row gap-4 md:gap-6 flex-1">
          <div className="w-24 h-24 md:w-32 md:h-32 rounded-full overflow-hidden border-4 border-primary/20 flex-shrink-0 mx-auto sm:mx-0">
            <Image
              src={pilgrim?.photo}
              alt={`Professional portrait photograph of ${pilgrim?.firstName} ${pilgrim?.lastName} wearing formal attire with neutral background for pilgrim identification`}
              className="w-full h-full object-cover"
            />
          </div>

          <div className="flex-1 text-center sm:text-left">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground mb-2">
              {pilgrim?.firstName} {pilgrim?.lastName}
            </h2>
            <p className="text-base md:text-lg text-muted-foreground mb-4">
              {pilgrim?.arabicFirstName} {pilgrim?.arabicLastName}
            </p>

            <div className="flex flex-wrap items-center justify-center sm:justify-start gap-3 md:gap-4 mb-4">
              <div className="flex items-center gap-2">
                <Icon name="FileText" size={16} className="text-muted-foreground" />
                <span className="caption text-muted-foreground">
                  {t('pilgrimProfile.caseNumber')}:
                </span>
                <span className="text-sm font-medium text-foreground data-text">
                  {pilgrim?.caseNumber}
                </span>
              </div>
              <span className={`px-3 py-1 rounded-full text-xs md:text-sm font-medium ${currentStatus?.color}`}>
                {currentStatus?.label}
              </span>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
              <div className="flex items-center gap-2">
                <Icon name="Mail" size={16} className="text-muted-foreground" />
                <span className="text-muted-foreground truncate">{pilgrim?.email}</span>
              </div>
              <div className="flex items-center gap-2">
                <Icon name="Phone" size={16} className="text-muted-foreground" />
                <span className="text-muted-foreground">{pilgrim?.phone}</span>
              </div>
              <div className="flex items-center gap-2">
                <Icon name="MapPin" size={16} className="text-muted-foreground" />
                <span className="text-muted-foreground">{pilgrim?.city}</span>
              </div>
              <div className="flex items-center gap-2">
                <Icon name="Calendar" size={16} className="text-muted-foreground" />
                <span className="text-muted-foreground">
                  {new Date(pilgrim.dateOfBirth)?.toLocaleDateString('en-US')}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-2 md:gap-3 lg:w-64">
          <Button
            variant="default"
            iconName="FileText"
            iconPosition="left"
            fullWidth
            onClick={() => onAction?.('requestDocument')}
          >
            {t('pilgrimProfile.requestDocument')}
          </Button>
          <Button
            variant="outline"
            iconName="CreditCard"
            iconPosition="left"
            fullWidth
            onClick={() => onAction?.('processPayment')}
          >
            {t('pilgrimProfile.processPayment')}
          </Button>
          <Button
            variant="outline"
            iconName="Users"
            iconPosition="left"
            onClick={handleAssignToGroup}
          >
            {t('pilgrimProfile.assignToGroup')}
          </Button>
          <Button
            variant="outline"
            iconName="MessageSquare"
            iconPosition="left"
            fullWidth
            onClick={() => onAction?.('sendMessage')}
          >
            {t('pilgrimProfile.sendMessage')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ProfileHeader;